
namespace TabAurous.Stock {

    @Serenity.Decorators.registerClass()
    export class StockForMaterialSelectGrid extends _Ext.GridBase<StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.StockItem'; } 
        protected getIdProperty() { return StockItemRow.idProperty; }
        protected getLocalTextPrefix() { return StockItemRow.localTextPrefix; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultEditorGridOptions) }
       
        //protected getColumns() {

        //    var _this = this;
        //    var columns = super.getColumns.call(this);
        //    columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
        //    if (StockForMaterialSelectGrid.ItemType == 2) {
        //        var newCols = columns.filter(x => x.field != "ItemType");
        //        newCols = newCols.filter(x => x.field != "NetWeight");
        //        newCols = newCols.filter(x => x.field != "Price");
        //        newCols = newCols.filter(x => x.field != "UserDescription");
        //        newCols = newCols.filter(x => x.field != "SKU");
        //        newCols = newCols.filter(x => x.field != "LineNo");
        //        newCols = newCols.filter(x => x.field != "HSN");
        //        //newCols = newCols.filter(x => x.field != "ItemType");
        //        columns = newCols;

        //    }
        //    columns = columns.filter(x => x.field != "HSN");
        //    columns = columns.filter(x => x.field != "SKU");
        //    return columns;
        //};

        constructor(container: JQuery,options) {
            super(container,options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            var x = this.view.getItems();
            this.slickGrid.setOptions({ rowHeight: 30 });
            return this;
        }
  /*      protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            let x;
            var lineno= [];
            if (StockForMaterialSelectGrid.LineNo != 0) {
                lineno.push(StockForMaterialSelectGrid.LineNo);
                lineno.push(0);
            }
            if (Stock.StockForMaterialSelectGrid.ItemType.toString() == "1") {
                StockItemService.CustomMaterialOutList({
                    ItemTypeIds: [101]
                },
                    response =>
                        x = response,
                    { async: false });

            } else if (Stock.StockForMaterialSelectGrid.ItemType.toString() == "2") {
                StockItemService.CustomMaterialOutList({
                    ItemTypeIds: [104, 105]
                },
                    response =>
                        x = response,
                    { async: false });

            } else if (Stock.StockForMaterialSelectGrid.ItemType.toString() == "4") {
                StockItemService.CustomMaterialOutList({
                    ItemTypeIds: [104],
                    ProductIds: StockForMaterialSelectGrid.productIds,
                    AttributeIds: StockForMaterialSelectGrid.attributeids,
                    KaratId: StockForMaterialSelectGrid.karatid
                },
                    response =>
                        x = response,
                    { async: false });

            }
            else if (Stock.StockForMaterialSelectGrid.ItemType.toString() == "3") {
                StockItemService.CustomMaterialOutList({
                    ProductIds: StockForMaterialSelectGrid.productIds,
                    AttributeIds: StockForMaterialSelectGrid.attributeids,
                    ItemTypeIds: [105],
                    LineNos: lineno
                },
                    response =>
                        x = response,
                    { async: false });

            } else if (Stock.StockForMaterialSelectGrid.ItemType.toString() == "5") {
                StockItemService.CustomMaterialOutList({
                    ItemTypeIds: [104],
                    KaratId: StockForMaterialSelectGrid.karatid,
                    MetalColorId: StockForMaterialSelectGrid.metalcolorid,
                },
                    response =>
                        x = response,
                    { async: false });

            }

            let y = [];
            
            let check = false;
            for (let rateitem of x.Entities) {
                rateitem[this.getIdProperty()] = rateitem.StockId;
                //   alert('ID ' + rateitem.CostId);
                check = true;
                this.view.addItem(rateitem);
            }
            //grid.setData(x1, true);
            //var c = grid.getData();
            if (!check) {
                this.view.setItems([],true);
            }
            return grid;
        }*/
        get selectedItems(): StockItemRow[] {
                var _this = this;
                return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
         
            return true;
           
        }
        
    } 
}